export default {
    general: {
        add:            'Dodaj',
        edit:           'Uredi',
        delete:         'Izbriši',
        cancel:         'Prekliči',
        save:           'Shrani',
        confirm:        'Potrdi',
        confirm_action: 'Potrdi dejanje',
        sign_out:       'Odjava',
        more_info:      'Več informacij',
        name:           'Ime',
        refresh:        'Osveži',
        actions:        'Dejanja',
        status:         'Stanje',
        details:        'Podrobnosti',
        type:           'Tip',
        overview:       'Pregled',
        settings:       'Nastavitve',
    },
    brand: {
        product_name: 'NervusEye',
        product_line: 'MONITOR',
        vendor:       'by iT TEAM d.o.o.',
        tagline:      'Upravljanje omrežnih operacij',
    },
    // Short labels for the navigation row; nav.* stays the full section name
    nav_short: {
        dashboard:     'Pregled',
        devices:       'Naprave',
        topology:      'Topologija',
        ipam:          'IPAM',
        documentation: 'Dokumenti',
        security:      'Varnost',
        syslog:        'Syslog',
        events:        'Dogodki',
        tools:         'Orodja',
        sla:           'SLA',
        templates:     'Predloge',
        users:         'Uporabniki',
        settings:      'Nastavitve',
        about:         'O aplikaciji',
    },
    nav: {
        dashboard:      'Nadzorna plošča',
        devices:        'Stablo naprav & Raziskovalec',
        topology:       'Topologija omrežja',
        ipam:           'IPAM & Inventar',
        security:       'Varnost vrat & Rogue detekcija',
        syslog:         'Syslog & SNMP Pasti',
        events:         'Dogodki in izpadi',
        sensors:        'Senzorji',
        administration: 'Administracija',
        templates:      'SNMP Predlogi',
        users:          'Uporabniški računi',
        settings:       'Sistemske nastavitve',
        changelog:      'Dnevnik sprememb',
        about:          'O programu & Pomoč',
    },
    common: {
        cancel: 'Prekliči',
        close:  'Zapri',
    },
    languages: {
        en:              'English',
        hr:              'Hrvatski',
        sl:              'Slovenščina',
        de:              'Deutsch',
        fr:              'Français',
        change_language: 'Spremeni jezik',
    },
    status: {
        up:           'Dostopno (UP)',
        down:         'Nedostopno (DOWN)',
        warning:      'Opozorilo',
        acknowledged: 'Potrjeno',
        paused:       'Zaustavljeno',
        unknown:      'Neznano',
    },
    dashboard: {
        title:                'Operativna nadzorna plošča',
        subtitle:             'Omrežna telemetrija v realnem času in zdravje infrastrukture',
        total_devices:        'Vse naprave',
        online_devices:       'Dostopne naprave',
        warning_devices:      'Opozorilo / Poslabšano',
        offline_devices:      'Nedostopne / Kritično',
        total_sensors:        'Aktivni senzorji',
        network_health:       'Zdravje omrežja',
        all_systems_ok:       'Vse nadzorovane naprave in senzorji delujejo brezhibno.',
        active_alerts:        'Aktivna opozorila in izpadi',
        active_alerts_desc:   'Naprave in senzorji, ki zahtevajo pozornost',
        recent_devices:       'Nadzorovane infrastrukturne naprave',
        explore_tree:         'Odpri stablo naprav',
        inspect:              'Preglej',
        auto_refresh:         'Samodejno osveževanje',
        arrange_graphs:       'Uredi / Razporedi grafe',
        done_arranging:       'Končaj urejanje',
        arrange_hint:         'Način razporejanja: Dodajte več grafov, povlecite kartice ali uporabite puščice za vrstni red.',
        grid_cols:            'Stolpci:',
        save_layout:          'Shrani razpored',
        select_sensor_to_add: 'Izberite senzor za dodajanje...',
        add_graph:            'Dodaj graf',
        layout_saved:         'Razpored grafov je shranjen',
        pause_sensor:         'Zaustavi senzor',
        top_metrics_title:    'Zmogljivost in Top Naprave',
        top_metrics_subtitle: 'Vpogledi v realnem času po porabi virov, prometu in stabilnosti',
        widgets_active:       'aktivno',
        top_cpu:              'Najvišja obremenitev CPE',
        top_cpu_desc:         'Naprave z najvišjim odstotkom porabe procesorja',
        top_ram:              'Najvišja poraba RAM-a',
        top_ram_desc:         'Naprave z največjo porabo delovnega pomnilnika',
        top_uptime:           'Dostopnost in Čas delovanja',
        longest_uptime:       'Najdaljši čas delovanja (Stabilnost)',
        recently_rebooted:    'Nedavno ponovno zagnani',
        top_ping:             'Najvišja latenca / Ping',
        top_ping_desc:        'Naprave z najdaljšim odzivnim časom omrežja (RTT)',
        top_traffic:          'Največji omrežni promet',
        top_port_errors:      'Napake na vratih & Zavrženi paketi',
        no_port_errors:       'Ni zaznanih napak na vratih ali izgube paketov',
        top_bgp:              'BGP seje',
        top_temperature:      'Temperatura in Strojna oprema',
        top_storage:          'Top Shramba / Disk',
        view_mode_grid:       'Mreža',
        view_mode_tabs:       'Zavihki',
        customize_widgets:    'Prilagodi gradnike',
        hosts_ranked:         'uvrščenih naprav',
        no_data:              'Ni podatkov',
    },
    tree: {
        search_placeholder: 'Iskanje naprav, IP, senzorjev...',
        filter_all:         'Vse',
        total_items:        'elementov',
        no_nodes_found:     'Ni elementov, ki ustrezajo iskanju',
        add_group:          'Dodaj skupino',
        add_folder:         'Dodaj mapo',
        add_device:         'Dodaj napravo',
        add_sensor:         'Dodaj senzor',
        root_title:         'Infrastrukturno stablo',
        back_to_tree:       'Nazaj na drevo',
    },
    devices: {
        title:                'Raziskovalec naprav',
        add_device:           'Dodaj napravo',
        edit_device:          'Uredi napravo',
        delete_device:        'Izbriši napravo',
        confirm_delete:       'Ali ste prepričani, da želite izbrisati to napravo in vse njene senzorje?',
        name:                 'Ime naprave',
        name_placeholder:     'npr. Core-Switch-01',
        hostname_ip:          'Ime gostitelja / IP',
        polling_interval:     'Interval poizvedovanja (s)',
        snmp_enabled:         'Omogoči SNMP',
        snmp_enabled_hint:    'Zajem MIB metrik in samodejno odkrivanje vmesnikov',
        snmp_version:         'Različica SNMP',
        snmp_port:            'SNMP Vrata',
        snmp_community:       'Skupnost (Community string)',
        poll_now:             'Poizvedi zdaj',
        polling_started:      'Ročno poizvedovanje sproženo',
        snmp_walk:            'SNMP Walk',
        snmp_walk_title:      'SNMP Walk Diagnostika',
        run_walk:             'Zaženi Walk',
        walking_mibs:         'Zajem OID drevesa...',
        no_walk_results:      'Ni najdenih OID rezultatov',
        device_details:       'Podrobnosti naprave',
        device_sensors:       'Konfigurirani senzorji',
        sensors_count:        'Senzorji',
        vendor:               'Proizvajalec',
        model:                'Model',
        last_polled:          'Zadnje poizvedovanje',
        no_devices_in_folder: 'V tej skupini/mapi ni naprav',
        select_node_hint:     'Izberite skupino, mapo ali napravo iz stabla na levi za prikaz podrobnosti.',
    },
    discovery: {
        title:               'Odkrivanje vmesnikov & Autodiscovery',
        scan_interfaces:     'Zajemi vmesnike',
        run_autodiscovery:   'Zaženi popolno samodejno odkrivanje',
        select_all:          'Izberi vse',
        deselect_all:        'Počisti izbiro',
        add_selected:        'Dodaj izbrane kot senzorje',
        scanning_hint:       'Poizvedovanje SNMP ifTable / ifXTable...',
        no_interfaces:       'Ni najdenih vmesnikov. Preverite SNMP povezljivost.',
        description:         'Opis / Alias',
        speed:               'Hitrost',
        discover_interfaces: 'Odkrij vmesnike',
    },
    sensors: {
        add_sensor:          'Dodaj senzor',
        edit_sensor:         'Uredi senzor',
        edit_sensor_title:   'Nastavitve senzorja',
        type:                'Tip senzorja',
        name:                'Ime senzorja',
        name_placeholder:    'npr. Ping Latenca',
        interval:            'Interval (s)',
        enabled:             'Senzor aktiven / omogočen',
        enabled_hint:        'Ko je onemogočen, poller preskoči osveževanje tega senzorja',
        oid:                 'SNMP OID',
        interface_index:     'Indeks vmesnika',
        last_reading:        'Zadnja vrednost',
        last_checked:        'Zadnji pregled',
        confirm_delete:      'Ali ste prepričani, da želite izbrisati ta senzor?',
        no_sensors_assigned: 'Za to napravo še ni dodeljenih senzorjev',
    },
    metrics: {
        title:      'Telemetrija v živo & Metrike',
        current:    'Trenutno',
        avg:        'Povprečje',
        min:        'Min',
        max:        'Max',
        no_data:    'Ni podatkov za izbrano obdobje',
    },
    templates: {
        title:                'SNMP Predlogi & MIB-i',
        subtitle:             'Predlogi za nadzor naprav in standardni profili proizvajalcev',
        add_template:         'Dodaj predlogo',
        edit_template:        'Uredi predlogo',
        import_template:      'Uvozi predloge',
        import_template_hint: 'Prilepite JSON strukturo za masovni uvoz predlog.',
        import_mib:           'Uvozi MIB',
        import_mib_hint:      'Naložite vsebino RFC ali vendor MIB datoteke za dopolnitev kataloga OID-ov.',
        export_all:           'Izvozi vse (JSON)',
        export:               'Izvozi',
        search_placeholder:   'Iskanje predlog po imenu, proizvajalcu...',
        templates_count:      'predlog',
        no_templates_found:   'Ni najdenih SNMP predlog',
        template_oids:        'Nastavljeni OID-i predloge',
        add_oid:              'Dodaj OID',
        no_oids_added:        'Ta predloga še nima določenih OID-ov.',
    },
    users: {
        title:            'Uporabniški računi',
        subtitle:         'Upravljanje operaterjev in pravic dostopa',
        add_user:         'Dodaj uporabnika',
        edit_user:        'Uredi uporabnika',
        accounts:         'Registrirani računi',
        username:         'Uporabniško ime',
        role:             'Vloga',
        password:         'Geslo',
        change_password:  'Spremeni geslo',
        old_password:     'Trenutno geslo',
        new_password:     'Novo geslo',
        confirm_password: 'Potrdi novo geslo',
        no_users_found:   'Ni najdenih uporabniških računov',
    },
    settings: {
        title:                 'Sistemske nastavitve',
        subtitle:              'Globalna konfiguracija, revizijska sled in varnostne kopije',
        general_tab:           'Splošno',
        general_preferences:   'Splošne nastavitve',
        appearance:            'Videz',
        appearance_info:       'Barvna tema tega brskalnika. Strani, meniji in zavihki ostanejo enaki; spremenijo se le barve, robovi in pisava.',
        theme_company:         'Podjetje',
        theme_company_desc:    'Barve NervusEye: cinkovo siva in oranžna',
        theme_classic:         'Klasična',
        theme_classic_desc:    'Videz prvega ZeroNMS: antracitna, skrilasta in modra',
        root_node_name:        'Ime korenskega vozlišča',
        default_traffic_unit:  'Privzeta enota za promet',
        audit_logs:            'Revizijska sled & Dnevnik sprememb',
        timestamp:             'Čas',
        action:                'Izvedeno dejanje',
        backup_recovery:       'Varnostno kopiranje & Obnovitev',
        console_tab:           'Aplikacije konzole',
        console_downloads:     'Prenos konzole',
        console_info:          'Izvorna namizna aplikacija, ki se hkrati poveže na več strežnikov NervusEye MONITOR in prikaže drevesa naprav, alarme in zgodovino senzorjev.',
        console_req_macos:     'macOS 14 Sonoma ali novejši, Apple silicon in Intel',
        console_req_windows:   'Windows 10 (1809) ali novejši, 64-bitni',
        console_req_android:   'Android 10 ali novejši',
        console_ios_note:      'iPhone in iPad: konzola se distribuira prek TestFlighta; za povabilo prosite skrbnika.',
        console_build:         'Build',
        console_size:          'Velikost',
        console_published:     'Objavljeno',
        console_download:      'Prenesi {file}',
        console_unavailable:   'Še ni na voljo',
        console_not_published: 'Na ta strežnik še ni objavljen namestitveni program.',
        console_loading:       'Nalaganje...',
        console_connect:       'Povezava s tem strežnikom',
        console_server_address:'Naslov strežnika',
        console_step_install:  'Namestite konzolo in jo odprite.',
        console_step_add:      'Izberite Add Server in prilepite zgornji naslov strežnika.',
        console_step_login:    'Prijavite se s svojim uporabniškim imenom in geslom NervusEye MONITOR.',
        run_backup:            'Ustvari varnostno kopijo zdaj',
        restore:               'Obnovi',
        notifications_tab:     'Opozorila in obvestila',
        notifications_title:   'Kanali za opozorila in obveščanje',
        telegram_title:        'Telegram Bot za opozorila',
        telegram_desc:         'Pošiljajte takojšnja potisna obvestila v zasebni klepet ali IT skupino na Telegramu.',
        telegram_enable:       'Omogoči Telegram opozorila',
        telegram_bot_token:    'Telegram Bot Token',
        telegram_token_help:   "Pridobite od {'@'}BotFather na Telegramu (npr. 123456789:ABCdefGhI...)",
        telegram_chat_id:      'Telegram Chat ID',
        telegram_chat_help:    'ID klepeta ali skupine (npr. -100123456789 za skupino)',
        telegram_test_btn:     'Pošlji preizkusno Telegram opozorilo',
        webhook_title:         'Webhook integracija',
        webhook_desc:          'Pošiljajte JSON opozorila v Discord, Slack, Microsoft Teams ali lastni HTTP naslov.',
        webhook_enable:        'Omogoči Webhook opozorila',
        webhook_url:           'Webhook URL naslov',
        webhook_url_help:      'Incoming webhook URL (npr. Discord ali Slack webhook)',
        webhook_test_btn:      'Pošlji preizkusno Webhook opozorilo',
        trigger_rules_title:   'Pravila sprožitve opozoril',
        notify_down:           'Obvesti ob izpadu / DOWN',
        notify_down_help:      'Pošlji opozorilo takoj, ko naprava ali senzor preide v stanje DOWN',
        notify_warning:        'Obvesti ob opozorilu / WARNING',
        notify_warning_help:   'Pošlji opozorilo, ko senzor preseže mejo opozorila',
        notify_recovery:       'Obvesti ob obnovitvi / RECOVERY',
        notify_recovery_help:  'Pošlji obvestilo o obnovitvi, ko se komponenta vrne v delovanje',
    },
    events: {
        title:            'Zgodovina izpadov in dogodkov',
        subtitle:         'Kronološki pregled omrežnih izpadov, opozoril in obnovitve',
        tab:              'Dogodki & Izpadi',
        total_outages:    'Skupaj izpadov',
        active_outages:   'Aktivni izpadi',
        resolved_outages: 'Rešeni incidenti',
        warnings:         'Opozorila',
        filter_device:    'Poišči napravo, IP ali senzor...',
        filter_status:    'Status',
        filter_resolved:  'Stanje',
        all_statuses:     'Vsi statusi',
        all_states:       'Vsa stanja',
        active_only:      'Samo aktivni',
        resolved_only:    'Samo rešeni',
        started_at:       'Čas začetka',
        ended_at:         'Čas obnovitve',
        duration:         'Trajanje izpada',
        component:        'Komponenta / Senzor',
        reason:           'Vzrok / Sporočilo',
        active:           'Aktiven izpad',
        resolved:         'Rešeno',
        no_events:        'Ni zabeleženih dogodkov za izbrane filtre.',
        ongoing:          'V teku',
    },
    layout: {
        open_menu:  'Odpri meni',
        more:       'Več',
        close_menu: 'Zapri meni',
    },
    color_mode: {
        switch_to_light: 'Preklopi na svetli način',
        switch_to_dark:  'Preklopi na temni način',
    },
    errors: {
        generic_error: 'Prišlo je do napake',
        invalid_data:  'Neveljavni podatki',
        not_found:     'Ni najdeno',
        unauthorized:  'Nepooblaščen dostop',
        on_add:        'Napaka pri dodajanju',
        on_edit:       'Napaka pri posodabljanju',
    },
    success: {
        add:  'Uspešno dodano',
        edit: 'Uspešno posodobljeno',
    },
    validation: {
        required: 'To polje je obvezno',
        email:    'Neveljaven e-poštni naslov',
    },
    syslog: {
        title:               'Centralni Syslog & SNMP Trap Sprejemnik',
        subtitle:            'Sprejem UDP 514 Syslog sporočil in UDP 162 SNMP pasti v realnem času ter takojšnje alarmiranje',
        live_Pause:          'Prenos v živo aktiven',
        paused:              'Prenos zaustavljen',
        simulate:            'Simuliraj dogodek / Trap',
        clear_old:           'Počisti stare zapise',
        total_messages:      'Vseh shranjenih dogodkov',
        last_24h:            'Dogodki (Zadnjih 24h)',
        critical_24h:        'Kritično / Alarmi (24h)',
        warnings_24h:        'Opozorila (24h)',
        syslog_vs_trap:      'Syslog proti SNMP Trap',
        top_categories:      'Najpogostejše kategorije:',
        search_placeholder:  'Išči sporočilo, mnemonik (%LINK-3-UPDOWN), IP, napravo...',
        all_protocols:       'Vsi protokoli',
        all_devices:         'Vse naprave',
        all_categories:      'Vse kategorije',
        all_severities:      'Vse stopnje resnosti',
        Critical_only:       'Samo kritično in napake (Sev 0-3)',
        warnings_and_up:     'Opozorila in višje (Sev 0-4)',
        notifications_and_up:'Obvestila in višje (Sev 0-5)',
        info_and_up:         'Informacije in višje (Sev 0-6)',
        col_time:            'Čas',
        col_protocol:        'Protokol',
        col_severity:        'Resnost',
        col_device:          'Izvorna naprava',
        col_category:        'Kategorija',
        col_mnemonic:        'Mnemonik / Trap OID',
        col_message:         'Sporočilo dogodka',
        no_messages:         'Ni najdenih Syslog ali SNMP Trap sporočil.',
        no_messages_hint:    'Usmerite usmerjevalnike/stikala na UDP vrata 514 (Syslog) ali 162 (SNMP Trap) ali kliknite "Simuliraj dogodek / Trap".',
        showing_count:       'Prikazano {shown} od {total} sporočil',
        simulate_desc:       'Vstavite simulirano Syslog ali SNMP Trap sporočilo za preizkus razčlenjevanja in obveščanja.',
        preset_template:     'Predloga dogodka',
        protocol:            'Protokol',
        source_device:       'Izvorna naprava',
        custom_ip:           'Zunanji IP naslov',
        source_ip:           'Izvorni IP naslov',
        hostname:            'Ime gostitelja',
        severity:            'Stopnja resnosti',
        category:            'Kategorija dogodka',
        mnemonic:            'Cisco Mnemonik / Identifikator',
        interface_opt:       'Vmesnik (Opcijsko)',
        message_body:        'Vsebina sporočila',
        send_simulation:     'Pošlji simuliran dogodek',
        sim_sent_title:      'Dogodek poslan',
        sim_sent_desc:       'Simulirano Syslog/Trap sporočilo je bilo obdelano.',
        cleared_title:       'Zapisi počiščeni',
        cleared_desc:        'Odstranjenih {count} starih zapisov.',
        detail_title:        'Podrobnosti dogodka in paketa',
        trap_oid:            'SNMP Trap OID',
        raw_payload:         'Izvorna vsebina paketa (Raw Payload)',
    },
    topology: {
        title:               'Topologija omrežja',
        subtitle:            'Samodejno odkrita L2/L3 topologija omrežja in povezave vrat stikal (CDP, LLDP in SNMP)',
        nodes_count:         '{count} vozlišč',
        links_count:         '{count} aktivnih povezav',
        ports_count:         '{count} povezanih vrat',
        view_mode:           'Pogled zemljevida:',
        view_wiring:         'Shema: Stikalo → MAC → Naprava',
        view_chassis:        'Fizični prikaz stikala (Faceplate)',
        view_ports:          'Zemljevid stikal in vrat',
        view_graph:          'Interaktivni graf omrežja',
        view_matrix:         'Tabela povezav (Patch Matrix)',
        filter_all:          'Vse',
        filter_switches:     'Stikala',
        filter_routers:      'Usmerjevalniki',
        filter_managed:      'Nadzorovani',
        search_placeholder:  'Filtriraj vozlišča, vrata, opise ali IP...',
        reset_layout:        'Ponastavi postavitev',
        refresh_scan:        'Osveži topologijo',
        scanning:            'Skeniram CDP/LLDP sosede in telemetrijo vrat...',
        legend_title:        'Legenda topologije',
        legend_monitored:    'Nadzorovana naprava (SNMP UP)',
        legend_external:     'CDP/LLDP sosed',
        legend_offline:      'Opozorilo / Nedosegljivo',
        status_label:        'Status vozlišča',
        status_monitored:    'Nadzorovana naprava',
        status_external:     'Odkriti sosed (CDP/LLDP)',
        type_label:          'Vrsta opreme',
        vendor_model:        'Proizvajalec in model',
        open_in_devices:     'Odpri v napravah',
        connected_links:     'Povezane povezave in vrata ({count})',
        local_port:          'Lokalna vrata',
        remote_port:         'Oddaljena vrata',
        port_alias:          'Opis vrat / Alias',
        connected_device:    'Povezana naprava / Sosed',
        protocol:            'Protokol',
        speed_traffic:       'Hitrost in promet v živo',
        switch_chassis_desc: 'Aktivna fizična in LAG vrata s CDP/LLDP sosedi in SNMP opisi',
        show_all_ports:      'Prikaži vsa aktivna označena vrata',
        show_cdp_only:       'Samo CDP / LLDP povezave',
        no_links_found:      'Ni najdenih povezav za izbrani filter.',
        unidentified_peer:   'Aktivna povezava',
        external_peers:      'Odkrita povezana oprema in končne naprave',
    },
    sensor_action: {
        ack_title:           'Potrditev alarma senzorja (ACK)',
        ack_title_edit:      'Uredi potrditev alarma (ACK)',
        pause_title:         'Zaustavi preverjanje senzorja',
        resume_title:        'Nadaljuj preverjanje senzorja',
        recorded_operator:   'Zabeležen operater',
        logged_in:           'Prijavljen',
        comment_label_ack:   'Komentar / razlog potrditve',
        comment_label_pause: 'Razlog zaustavitve / vzdrževanja',
        visible_to_team:     'Vidno celotni ekipi',
        comment_ph_ack:      'npr. Vzdrževanje povezave v teku, izpad ponudnika, menjava opreme...',
        comment_ph_pause:    'npr. Načrtovano vzdrževanje, začasno izklopljeno zaradi testiranja...',
        btn_clear_ack:       'Odstrani ACK',
        btn_ack:             'Potrdi senzor (ACK)',
        btn_update_comment:  'Shrani komentar',
        btn_pause:           'Zaustavi preverjanje',
        btn_resume:          'Nadaljuj preverjanje',
        btn_resume_now:      'Nadaljuj zdaj',
        btn_acked:           'Potrjeno',
        acked_by:            'Potrdil',
        paused_by:           'Zaustavil',
        no_comment:          'Brez opombe',
        banner_acked:        'Alarm senzorja je potrjen',
        banner_paused:       'Preverjanje senzorja je zaustavljeno',
        edit_comment:        'Uredi komentar',
        clear_ack:           'Odstrani ACK',
        success_ack:         'Alarm senzorja je potrjen',
        success_unack:       'Potrditev alarma je odstranjena',
        success_pause:       'Preverjanje senzorja je zaustavljeno',
        success_resume:      'Preverjanje senzorja je nadaljevano',
        presets: {
            maintenance:       'Vzdrževalna dela v teku',
            isp_outage:        'Izpad ponudnika - prijavljena napaka',
            hardware_replace:  'Čaka se menjava SFP / opreme',
            known_issue:       'Znan problem - reševanje v teku',
            investigating:     'Začasen izpad - spremljanje stanja',
            pause_maintenance: 'Načrtovano vzdrževanje opreme',
            pause_testing:     'Začasno izklopljeno zaradi testiranja',
            pause_disabled:    'Naprava ne deluje do nadaljnjega',
            pause_customer:    'Uporabniški priključek ugasnjen',
            pause_monitoring:  'Zaustavljeno spremljanje',
        },
    },
    inspector: {
        title_up:           'Delujoči senzorji in naprave (UP)',
        title_down:         'Kritični senzorji in izpadi (DOWN)',
        title_warning:      'Opozorila in poslabšani senzorji (WARN)',
        title_ack:          'Potrjeni senzorji (ACK)',
        title_paused:       'Zaustavljeni senzorji / Vzdrževanje (PAUSED)',
        title_unknown:      'Neznani / Nepreverjeni senzorji (UNKNOWN)',
        subtitle:           'Podrobni opisi senzorjev, telemetrija, potrditve (ACK) in razlogi zaustavitve.',
        matching:           'ustreza',
        close_filter:       'Zapri filter',
        search_placeholder: 'Išči senzor, napravo, komentar ali uporabnika...',
        no_matching:        'Trenutno ni senzorjev ali naprav s statusom',
        th_status:          'Status',
        th_device:          'Naprava',
        th_sensor_name:     'Ime senzorja / vozlišča',
        th_type:            'Vrsta',
        th_detail:          'Opis senzorja & ACK / Pause podrobnosti',
        th_reading:         'Trenutno odčitavanje',
        th_last_checked:    'Zadnji pregled',
        th_actions:         'Dejanja',
        inspect:            'Preglej',
        clone_sensor:       'Kloniraj senzor',
        showing:            'Prikazano',
        of:                 'od',
        specs_title:        'Konfiguracija senzorja in mejne vrednosti',
        sensor_id:          'ID senzorja',
        check_interval:     'Interval preverjanja',
        alarm_thresholds:   'Mejne vrednosti alarmov',
        edit_thresholds:    'Uredi mejne vrednosti / senzor',
    },
    bgp: {
        session_uptime:        'Čas delovanja seje (Uptime)',
        remote_as:             'Oddaljeni AS / Peer',
        asn_lookup_title:      'Pregled avtonomnega sistema (ASN)',
        asn_lookup_btn:        'AS Pregled',
        asn_input_placeholder: 'Vnesite AS številko (npr. 13335, AS5448, 65400)...',
        quick_presets:         'Hitra izbira:',
        querying_whois:        'Pridobivanje WHOIS in RIPE Stat zapisov...',
        private_as:            'Zasebni AS',
        public_as:             'Javni AS',
        network_type:          'Vrsta omrežja',
        description:           'Opis',
        external_tools:        'Zunanja BGP orodja in Looking Glass',
        lookup_as:             'Preveri AS',
        enter_valid_as:        'Prosimo vnesite veljavno AS številko',
        asn_not_found:         'Podatkov o AS številki ni bilo mogoče najti',
        network_error:         'Omrežna napaka pri poizvedovanju ASN',
        resolving:             'Pridobivam...',
        established:           'Vzpostavljeno',
    },
    scanner: {
        port_scan_title:      'Skeniranje vrat & Storitve',
        port_scan_hint:       'Samodejno zazna odprte storitve (SSH, HTTP, DNS, Winbox, BGP) in ustvari skupino senzorjev',
        profile:              'Profil skeniranja',
        profile_well_known:   'Standardne storitve (~75 vrat, <1s)',
        profile_common_1024:  'Standardna vrata 1-1024 (~1s)',
        profile_top_1000:     'Top 1000 vrat (~2s)',
        scan_now:             'Skeniraj zdaj',
        enter_ip_first:       'Pred skeniranjem vnesite IP naslov naprave',
        scan_failed:          'Skeniranje vrat ni uspelo',
        found_ports:          'Najdenih {count} odprtih vrat ({duration} ms)',
        no_open_ports:        'Ni odprtih vrat',
        open_ports_tab:       'Odprta vrata & Storitve',
        open_ports_title:     'Odprta vrata & Omrežne storitve',
        rescan_now:           'Skeniraj vrata',
        add_all_as_sensors:   'Dodaj vse kot senzorje',
        open_ports_count:     'Odprta vrata',
        scan_speed:           'Hitrost zadnjega skeniranja',
        target_ip:            'Ciljni IP naslov',
        active_sensors:       'Aktivni senzorji vrat',
        search_placeholder:   'Išči po vratih, protokolu ali storitvi...',
        empty_hint:           'Za to napravo še ni zabeleženih odprtih vrat. Zaženite hitro večnitno skeniranje.',
        start_scan:           'Zaženi skeniranje vrat',
        col_port:             'Vrata / Protokol',
        col_service:          'Storitev',
        col_description:      'Opis storitve',
        col_latency:          'Odzivnost',
        col_status:           'Stanje',
        col_action:           'Senzor v drevesu',
        sensor_active:        'Senzor aktiven',
        create_sensor:        'Dodaj senzor',
        scan_completed:       'Najdenih {count} odprtih vrat v {duration}ms',
    },
}


